import * as React from 'react'

function SvgTips(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.417 18.696l1.377-.886A6.942 6.942 0 0022 11.96C22 8.127 18.877 5 15 5s-7 3.127-7 6.96a6.942 6.942 0 003.206 5.85l1.377.886v2.213H14V12a1 1 0 10-1 1 1 1 0 110 2 3 3 0 112-5.236A3 3 0 1117 15a1 1 0 110-2 1 1 0 10-1-1v8.91h1.417v-2.214zm3 1.637C23.174 18.56 25 15.473 25 11.96 25 6.46 20.523 2 15 2S5 6.46 5 11.96c0 3.512 1.826 6.6 4.583 8.373v1.576a2 2 0 002 2h6.834a2 2 0 002-2v-1.576zM10 26.5a1.5 1.5 0 011.5-1.5h7a1.5 1.5 0 010 3h-7a1.5 1.5 0 01-1.5-1.5z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgTips
